// extracted by mini-css-extract-plugin
export var statItem = "_m7-1";
export var statsRow = "_m7-0";